<button
    (click)="showPermalinkDialog()"
    [disabled]="!storedReportId"
    hisImage="link"
    class="plamButton icon"
    title="{{ 'common.permalink.title' | hisUi }} {{ reportName }}">
    {{ "cs.bia.permalink.create" | hisUi }}
</button>
@if (storedReportId) {
    <p-dialog
        header="{{ 'common.permalink.title' | hisUi }} {{ reportName }}"
        [(visible)]="visible"
        [closable]="true">
        <div class="layoutBlock">
            <div class="columnHalf">
                <fieldset class="fieldsetGroup">
                    <legend
                        #content
                        class="legendTag">
                        {{ "cs.bia.permalink.target.header" | hisUi }}
                    </legend>
                    @for (target of linkTargets; track target) {
                        <p>
                            @if (!target.hide) {
                                <input
                                    type="radio"
                                    name="linkTarget"
                                    [id]="target.id"
                                    (change)="changeTarget(target)"
                                    [checked]="target === this.selectedTarget" />
                            }
                            @if (!target.hide) {
                                <label [for]="target.id">{{ target.label | hisUi }}</label>
                            }
                        </p>
                    }
                </fieldset>
            </div>
        </div>
        <label htmlFor="permalinkText">{{ "cs.bia.permalink.preview" | hisUi }}</label>
        <div></div>
        <textarea
            id="permalinkText"
            pInputTextArea
            [(ngModel)]="permalink"
            [rows]="5"
            [cols]="80"
            #permalinkText>
        </textarea>
        <p>
            <his-bi-copy-open-link [permalink]="permalink"></his-bi-copy-open-link>
        </p>
        <p>
            <button (click)="visible = false">
                {{ "view.controls.close_button" | hisUi }}
            </button>
        </p>
    </p-dialog>
}
